module.exports = __webpack_public_path__ + "images/psp/FeaturedImages/car1.webp";